import { useState, useEffect, useContext, useRef } from 'react'
import ContextStates from '../../context/ContextStates'
import { Link } from 'react-router-dom'
import { useFormik } from "formik"
import { FaPlus } from "react-icons/fa";
import SubirImagenes from '../SubirImagenes';
import * as Yup from "yup"
import axios from 'axios'
import { Url } from '../Url'


const FormProducto = () => {
    const [codigo, setCodigo] = useState('')
    const [descripcion, setDescripcion] = useState('')
    const [descripcionExt, setDescripcionExt] = useState('')
    const [productoExist, setProductoExist] = useState('')
    const [precio, setPrecio] = useState('')
    const [precioCosto, setPrecioCosto] = useState('')
    const [precioPromo, setPrecioPromo] = useState('')
    const [precioMayor, setPrecioMayor] = useState('')
    const [stock, setStock] = useState('')
    const [stockMin, setStockMin] = useState('')
    const [marcas, setMarcas] = useState([])
    const [marca, setMarca] = useState(0)
    const [idProducto, setIdProducto] = useState(0)

    const [rubros, setRubros] = useState([])
    const [rubro, setRubro] = useState(0)

    /*const [modelos, setModelos] = useState([])
    const [modelo, setModelo] = useState(0)*/

    const [talles, setTalles] = useState([])
    const [talle, setTalle] = useState(0)

    const [colores, setColores] = useState([])
    const [color, setColor] = useState(0)

    const [bgColor, setBgColor] = useState('')

    const [guardar, setGuardar] = useState(false)
    const { modify, setModify, setFormView, setViewOpen, valModelo, idUsuario, valMarca, valRubro, roles } = useContext(ContextStates)

    let tipoImagen = "productos";
    let idHtml = "imagenesProducto";
    const childRef = useRef()

    useEffect(() => {
        if (idProducto !== 0) {
            console.log("arranca la subida de imagen")
            childRef.current.handleSubmit();
        }
    }, [idProducto])

    useEffect(() => {
        const consultaMarcas = async () => {
            const formData = new FormData()
            formData.append("marcacero", 0)
            try {
                const response = await axios({
                    url: Url + 'api/listadomarcas.php',
                    method: 'POST',
                    data: formData,
                })
                setMarcas(response.data.results)
                setMarca(response.data.results[0].id)
            } catch (e) {
                console.log(e)
            }
        }
        consultaMarcas()
    }, [valMarca])

    useEffect(() => {
        const consultaRubros = async () => {
            const url = Url + 'api/listRubros.php';
            const resultado = await axios.get(url);
            setRubros(resultado.data.results);
            setRubro(resultado.data.results[0].id)
        }
        consultaRubros()
    }, [valRubro])

    useEffect(() => {
        colores.forEach(element => {
            if (element.id === color) {
                setBgColor(element.codigo)
            }
        });
    }, [color])


    useEffect(() => {
        const consultaTalles = async () => {
            const formData = new FormData()

            try {
                const response = await axios({
                    url: Url + 'api/listadotalles.php',
                    method: 'POST',
                    data: formData,
                })
                setTalles(response.data.results)
                setTalle(response.data.results[0].id)
            } catch (e) {
                console.log(e)
            }
        }
        consultaTalles()
    }, [])

    useEffect(() => {
        const consultaColores = async () => {
            const formData = new FormData()

            try {
                const response = await axios({
                    url: Url + 'api/listadocolores.php',
                    method: 'POST',
                    data: formData,
                })
                if (typeof response.data.results !== 'undefined') {
                    setColores(response.data.results)
                    setColor(response.data.results[0].id)
                }
            } catch (e) {
                console.log(e)
            }
        }
        consultaColores()
    }, [])

    const altaProducto = async () => {
        if (guardar) {
            setGuardar(false)
            const formData = new FormData()
            formData.append('codigo', codigo);
            formData.append('descripcion', descripcion);
            formData.append('descripcionext', descripcionExt);
            formData.append('idmarca', marca);
            formData.append('idrubro', rubro);
            formData.append('color', color);
            formData.append('precio', precio);
            formData.append('preciocosto', precioCosto);
            formData.append('preciopromo', precioPromo);
            formData.append('preciomayor', precioMayor);
            formData.append('stock', stock);
            formData.append('stockMin', stockMin);
            formData.append('idusuario', idUsuario);
            try {
                const results = await axios({
                    url: Url + 'api/altaProductos.php',
                    method: 'POST',
                    data: formData,
                })
                let aux = modify + 1;
                setModify(aux)
                setCodigo('');
                setDescripcion('');
                setDescripcionExt('');
                setPrecio('');
                setPrecioCosto('');
                setStock('');
                setStockMin('');
                setPrecioPromo('');
                setPrecioMayor('');
                setIdProducto(results.data.results.id)
            } catch (e) {
                console.log(e)
            }
        }
    }

    useEffect(() => {
        const checkProducto = async () => {
            if (codigo !== '') {
                const formData = new FormData()
                formData.append('codigo', codigo);

                try {
                    const results = await axios({
                        url: Url + 'api/checkProducto.php',
                        method: 'POST',
                        data: formData,
                    })
                    console.log(results)
                    if (typeof results.data.results.descripcion !== 'undefined') {
                        setProductoExist(results.data.results.descripcion);
                    }
                    else {
                        setProductoExist('');
                    }

                } catch (e) {
                    console.log(e)
                }
            }
        }
        checkProducto()
    }, [codigo])

    useEffect(() => {
        const checkForm = () => {
            let error = 0;
            if (descripcion === '')
                error = 1;
            if (precio === '')
                error = 1;
            if (codigo === '')
                error = 1;
            if (stock === '')
                error = 1;

            if (error === 0)
                setGuardar(true)
            else
                setGuardar(false)
        }
        checkForm()
    }, [descripcion, codigo, precio, stock])

    const handleAdd = (form) => {
        setFormView(form)
        setViewOpen(true)
    }

    return (

        <div className="transition-all w-full pt-5 sm:p-3 mt-5">
            {roles.includes("10") && (
                <>
                    <h2 className='text-center text-gray-700 text-xl'>Alta de Productos</h2>
                    <div className="w-full mt-5 py-2 px-3 rounded-2xl">
                        <div className='md:flex'>
                            <div className='w-full md:w-1/2 mx-auto m-3 p-2'>
                                <div className='p-3 bg-white border border-gray-200 rounded-lg shadow-xl'>
                                    <h4 className='text-center text-gray-700 uppercase'>Producto, rubro, marca y modelo</h4>
                                    <div className="sm:items-start">
                                        <label htmlFor="codigo" className="block mt-5 text-gray-600 uppercase">Código</label>
                                        <input
                                            className="py-2 px-3 w-full border border-gray-300 rounded"
                                            id="codigo"
                                            placeholder="Código de producto"
                                            type="text"
                                            value={codigo}
                                            onChange={(e) => setCodigo(e.target.value)}
                                            autoFocus
                                        />
                                    </div>
                                    {productoExist !== '' && (
                                        <div className='w-full p-3 rounded-lg bg-orange-200 border border-orange-300'>
                                            <p className='text-center'>Existe el producto {productoExist} con el código {codigo}</p>
                                        </div>
                                    )}
                                    <div className="sm:items-start">
                                        <label htmlFor="descripcion" className="block mt-5 text-gray-600 uppercase">Descripción</label>
                                        <input
                                            className="py-2 px-3 w-full border border-gray-300 rounded"
                                            id="descripcion"
                                            placeholder="Descripción"
                                            type="text"
                                            value={descripcion}
                                            onChange={(e) => setDescripcion(e.target.value)}
                                        />
                                    </div>
                                    <div className="sm:items-start mt-5">
                                        <label htmlFor="descripcionExt" className="block text-gray-600 uppercase">Descripción detallada</label>
                                        <input
                                            className="py-2 px-3 w-full border border-gray-300 rounded"
                                            id="descripcionExt"
                                            placeholder="Ingrese una descripción detallada"
                                            type="text"
                                            value={descripcionExt}
                                            onChange={(e) => setDescripcionExt(e.target.value)}
                                        />
                                    </div>
                                    <label htmlFor="sRubro" className="w-full block mt-5 text-gray-600 uppercase">Rubro</label>

                                    <div className='flex'>
                                        <select
                                            className='py-2 px-3 w-full rounded bg-slate-100 mr-2'
                                            id='sRubro'
                                            value={rubro}
                                            onChange={(e) => setRubro(e.target.value)}
                                        >
                                            {rubros && (
                                                rubros.map(item => (
                                                    <option key={item.id} value={item.id}>{item.descripcion}</option>))
                                            )}
                                        </select>
                                        <button
                                            type='button'
                                            className=' bg-violet-600 p-3 rounded-lg text-white'
                                            onClick={() => handleAdd(6)}
                                        ><FaPlus /></button>
                                    </div>
                                    <label htmlFor="sMarca" className="w-full block mt-5 text-gray-600 uppercase">Marca</label>
                                    <div className='flex'>
                                        <select
                                            className='py-2 px-3 w-full rounded bg-slate-100 mr-2'
                                            id='sMarca'
                                            value={marca}
                                            onChange={(e) => setMarca(e.target.value)}
                                        >
                                            {marcas && (
                                                marcas.map(item => (
                                                    <option key={item.id} value={item.id}>{item.descripcion}</option>))
                                            )}
                                        </select>
                                        <button
                                            type='button'
                                            className=' bg-violet-600 p-3 rounded-lg text-white'
                                            onClick={() => handleAdd(4)}
                                        ><FaPlus /></button>
                                    </div>
                                    <label htmlFor="sTalle" className="w-full block mt-5 text-gray-600 uppercase">Talle</label>
                                    <div className='flex'>
                                        <select
                                            className='py-2 px-3 w-full rounded bg-slate-100 mr-2'
                                            id='sTalle'
                                            value={talle}
                                            onChange={(e) => setTalle(e.target.value)}
                                        >
                                            {talles && (
                                                talles.map(item => (
                                                    <option key={item.id} value={item.id}>{item.nombre}</option>))
                                            )}
                                        </select>
                                    </div>
                                    <label htmlFor="sColor" className="w-full block mt-5 text-gray-600 uppercase">Color</label>
                                    <div className='flex'>
                                        <select
                                            className='py-2 px-3 w-full rounded bg-slate-100 mr-2'
                                            id='sColor'
                                            value={color}
                                            onChange={(e) => setColor(e.target.value)}
                                        >
                                            {colores && (
                                                colores.map(item => (
                                                    <option key={item.id} value={item.id}>{`${item.nombre}`}</option>))
                                            )}
                                        </select>
                                        <div className={`p-2 w-1/4 bg-${bgColor}`}></div>
                                    </div>
                                    <SubirImagenes
                                        id={idProducto}
                                        tipo={tipoImagen}
                                        ref={childRef}
                                        idHtml={idHtml}
                                    />
                                </div>
                            </div>
                            <div className='w-full md:w-1/2 mx-auto m-3 p-2'>
                                <div className='p-3 bg-white border border-gray-200 rounded-lg shadow-xl'>
                                    <h4 className='text-center text-gray-700 uppercase'>Precio, unidad y Stock</h4>
                                    <div className="sm:items-start">

                                        <label htmlFor="precio" className="block mt-5 text-gray-600 uppercase">Precio de venta</label>
                                        <input
                                            className="py-2 px-3 w-full border border-gray-300 rounded"
                                            id="precio"
                                            placeholder="Precio de venta"
                                            type="text"
                                            value={precio}
                                            onChange={(e) => setPrecio(e.target.value)}
                                        />
                                    </div>
                                    <div className="sm:items-start">

                                        <label htmlFor="precioCosto" className="block mt-5 text-gray-600 uppercase">Precio de costo</label>
                                        <input
                                            className="py-2 px-3 w-full border border-gray-300 rounded"
                                            id="precioCosto"
                                            placeholder="Precio de costo"
                                            type="text"
                                            value={precioCosto}
                                            onChange={(e) => setPrecioCosto(e.target.value)}
                                        />
                                    </div>
                                    <div className="sm:items-start">

                                        <label htmlFor="precioMayor" className="block mt-5 text-gray-600 uppercase">Precio por mayor</label>
                                        <input
                                            className="py-2 px-3 w-full border border-gray-300 rounded"
                                            id="precioMayor"
                                            placeholder="Precio por mayor"
                                            type="text"
                                            value={precioMayor}
                                            onChange={(e) => setPrecioMayor(e.target.value)}
                                        />
                                    </div>
                                    <div className="sm:items-start">
                                        <label htmlFor="precioPromo" className="block mt-5 text-gray-600 uppercase">Precio de Promoción</label>
                                        <input
                                            className="py-2 px-3 w-full border border-gray-300 rounded"
                                            id="precioPromo"
                                            placeholder="Precio de Promoción"
                                            type="text"
                                            value={precioPromo}
                                            onChange={(e) => setPrecioPromo(e.target.value)}
                                        />
                                    </div>
                                    <div className='flex'>
                                        <div className="w-1/2 mr-2 sm:items-start">
                                            <label htmlFor="stock" className="block mt-5 text-gray-600 uppercase">Stock</label>
                                            <input
                                                className="py-2 px-3 w-full border border-gray-300 rounded"
                                                id="stock"
                                                placeholder="Stock"
                                                type="text"
                                                value={stock}
                                                onChange={(e) => setStock(e.target.value)}
                                            />
                                        </div>
                                        <div className="w-1/2 ml-2 sm:items-start">
                                            <label htmlFor="stockMin" className="block mt-5 text-gray-600 uppercase">Stock mínimo</label>
                                            <input
                                                className="py-2 px-3 w-full border border-gray-300 rounded"
                                                id="stockMin"
                                                placeholder="Stock mínimo"
                                                type="text"
                                                value={stockMin}
                                                onChange={(e) => setStockMin(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mt-auto">
                            <button
                                type="button"
                                className={`"shadow-md mx-auto p-3 text-gray-100 hover:text-gray-300 transition-all uppercase font-bold rounded-lg mt-5" ${guardar ? 'bg-orange-600' : 'bg-orange-300'}`}
                                onClick={() => altaProducto()}
                            >
                                Guardar Datos
                            </button>

                            <Link to={"/admin/productos"} >
                                <button
                                    type='button'
                                    className='shadow-md p-3 text-gray-100 hover:text-gray-300 transition-all uppercase font-bold rounded-lg mt-5 bg-gray-500'
                                >Volver a Productos</button>
                            </Link>
                        </div>

                    </div>
                </>
            )}

        </div>
    )
}

export default FormProducto